import type { ShopWebsiteConfig } from '@/services/shopWebsiteService'
import { shopStorefrontCanonicalPath } from '@/lib/shopStorefrontLayout'
import { ShopStorefrontHead } from '@/components/shop/ShopStorefrontHead'

type ShopComingSoonPageProps = {
  config: ShopWebsiteConfig
  basePath: string
}

export function ShopComingSoonPage({ config, basePath }: ShopComingSoonPageProps) {
  const primary = '#4f46e5'

  return (
    <div className="min-h-screen bg-slate-50">
      <ShopStorefrontHead
        config={config}
        canonicalPath={shopStorefrontCanonicalPath(basePath, config.slug || '')}
      />
      <div className="mx-auto flex min-h-screen max-w-lg flex-col items-center justify-center px-6 py-16 text-center">
        {config.logo_url ? (
          <img
            src={config.logo_url}
            alt=""
            className="mb-6 h-16 w-auto max-w-[12rem] object-contain"
          />
        ) : null}
        <h1 className="text-2xl font-semibold text-slate-900">{config.name}</h1>
        <p
          className="mt-4 inline-flex rounded-full px-4 py-1.5 text-sm font-medium text-white"
          style={{ backgroundColor: primary }}
        >
          Coming soon
        </p>
      </div>
    </div>
  )
}
